import {useContext, useEffect, useRef} from "react";
import SocketContext from "../Services/Socket/SocketContext";
import request from "../Services/API/Requests";

/**
 *
 * @param events
 * @param doActions
 * @param context
 */
const useWebSocket = (events = [], doActions, context) => {
    const {subscribe, unSubscribe} = useContext(SocketContext) || {};
    const webEvent = useRef(null);

    useEffect(() => {
        async function getEvents() {
            try {
                if (events && events.length) {
                    const webEventIndex = events.findIndex(event => event.event === 'onWebEvent');
                    if (webEventIndex !== -1) {
                        const resEvent = await request({
                            url: 'webEvent/read',
                            data: {
                                id: events[webEventIndex].webEvent
                            }
                        })

                        webEvent.current = resEvent;

                        setTimeout(() => {
                            subscribe(resEvent, doActions, events[webEventIndex].actions, context)
                        }, 2000)

                    }
                }
            } catch (e) {
                console.log('get events error', e)
            }
        }

        getEvents()

        return () => {
            if (webEvent.current) {
                console.log('disconnecting...')
                unSubscribe(webEvent.current)
            }
        }
    }, [JSON.stringify(events)])


}

export default useWebSocket